import React from 'react';

import { BookSortingEnum } from '~/api/book/bookApiTypes';
import { PostLink } from '~/atomic/atom/links/dynamicLinks';
import { getBooks } from '~/atomic/page/catalog/tagPage/tagPage.data';
import { tagFiltersSelector } from '~/atomic/page/catalog/tagPage/tagPage.selector';
import { Contest } from '~/atomic/page/contest/Contest';
import { catalogFilterActions } from '~/feature/catalog/filter/catalogFilter.slice';
import { paginationActions } from '~/feature/pagination/pagination.slice';
import { useAppDispatch, useAppSelector } from '~/store';

export const CONTEST_DUKE_RECTOR_TWO_DRAGONS_TAG_SLUG = 'gertsog-rektor-dva-drakona';

export const ContestDukeRectorTwoDragons = () => {
  const dispatch = useAppDispatch();
  const { books, isLoadBooks } = useAppSelector(tagFiltersSelector);

  const onLoadBooks = () => {
    dispatch(paginationActions.setPageSize({ perPage: 100 }));
    dispatch(catalogFilterActions.setTagSlug(CONTEST_DUKE_RECTOR_TWO_DRAGONS_TAG_SLUG));
    dispatch(getBooks());
  };

  const onLoadSidebarBooks = () => {
    dispatch(paginationActions.setPageSize({ perPage: 6 }));
    dispatch(catalogFilterActions.setBookSorting(BookSortingEnum.Rand));
    dispatch(catalogFilterActions.setTagSlug(CONTEST_DUKE_RECTOR_TWO_DRAGONS_TAG_SLUG));
    dispatch(getBooks());
  };

  return (
    <Contest
      bannerProps={{ bannerSrc: '/image/contest/duke-rector-two-dragons/banner.jpg' }}
      commentProps={{
        targetId: 4459,
        targetAuthorId: String(1493),
      }}
      contestBooksProps={{
        books,
        isLoading: isLoadBooks,
        onLoadBooks,
        description: 'Конкурс фэнтезийных любовных романов «Герцог, ректор, два дракона»!',
      }}
      contestSidebarBooksProps={{
        books,
        isLoading: isLoadBooks,
        onLoadBooks: onLoadSidebarBooks,
      }}
      contestResults={{
        winnerBookSlugs: ['nina-lindt90020-kholodnyi-veter-stroptivaya-voda', 'DaryaFair-yasminovyi-tsvet-zakata'],
        secondPlace: ['olga-lisenkova-nevesta-khranitelya-stikhii'],
        thirdPlace: ['danielle-braen-klassnaya-dama'],
        shortList: ['anna-ledova-uzh-zamuzh-nevterpezh'],
      }}
      descriptionProps={{
        content: (
          <>
            <p style={{
              textAlign: 'center',
              color: 'var(--green2-color)',
              fontSize: '18px',
              marginBottom: '16px',
            }}
            >
              Прием заявок окончен. Идет работа жюри.
            </p>
            <p style={{ textAlign: 'center' }}><b>По просьбе жюри сроки оглашения победителей сдвигаются на конец ноября \ начало декабря</b></p>
            <p>
              <span>
                «Bookriver» совместно с издательским домом «АСТ» проводит конкурс фэнтезийных любовных романов
              </span>
              <b> «Герцог, ректор, два дракона»!</b>
            </p>
            <p>
              <span>
                Конкурс посвящается неунывающим попаданкам, которые,
                оказавшись в магическом мире,
                берут себя в руки и не только
                завоевывают себе место под&nbsp;
                иномирским светилом, но и находят свою любовь.
              </span>
            </p>
            <p>
              <span>
                На конкурс принимаются работы в жанре любовное фэнтези + попаданцы.
                Подробности вы можете посмотреть в разделе «Условия участия».
              </span>
            </p>
            <p>
              <h3>Сроки проведения конкурса</h3>
            </p>
            <p>
              <b>Прием заявок:</b>
              <span> до 15.08.2023г. включительно.</span>
            </p>
            <p>
              <b>Работа жюри, формирование шорт-листа:</b>
              <span> август-сентябрь 2023 года.</span>
            </p>
            <p>
              <b>Оглашение победителей:</b>
              <span> конец сентября — начало октября 2023 года.</span>
            </p>
            <p><i>Сроки могут быть изменены по решению организаторов.</i></p>
            <h3>Призы</h3>
            <p>
              <b>Первое место</b>
              <i>(первые места*): </i>
              <span>заключение договора с АСТ, издание вашего романа.</span>
            </p>
            <p>
              <b>Второе место:</b>
              <span> 30&nbsp;000 рублей.</span>
            </p>
            <p>
              <b>Третье место:</b>
              <span> 15&nbsp;000 рублей.</span>
            </p>
            <p>
              <span>
                Для всех, попавших в шорт-лист,
                мы предоставим бесплатный месяц рекламы
                от портала на конкурсное произведение
                и персональный баннер на главной странице после оглашения победителей.
              </span>
            </p>
            <p>
              <i>
                * Издательство оставляет за собой
                право выбрать несколько победителей, заключив договор с каждым из них.
              </i>
            </p>
            <p><h3>Выбор победителя</h3></p>
            <p>
              <b>Лонг-лист</b>
              <span> формируется на основании присланных участниками синопсисов.</span>
            </p>
            <p>
              <b>Шорт-лист</b>
              <span>
                {' '}
                формируется на основании литературно художественных достоинств текста,
                а так же — учитывается максимальное соответствие произведения тематике конкурса
                и читательский отклик (посещаемость, комментарии, библиотеки, покупки).
                В интересах автора вести читателя на страницу конкурсного романа, однако
                мы призываем не использовать накрутки — это будет строго отслеживаться,
                замеченные в нечестной игре будут сняты с конкурса.
              </span>
            </p>
            <p>
              <b>Жюри:</b>
              <span> команда Bookriver и редактор отдела «Жанры» издательства «АСТ» Марья Емельянова.</span>
            </p>
            <p><h3>Условия участия</h3></p>
            <p>
              <span>
                Конкурсное произведение должно быть завершено не ранее 2023 года,
                не должно иметь издания в бумаге (ни самостоятельного, ни от какого-либо
                издательства), не должно распространяться бесплатно на постоянной основе.
                Наличие у произведения аннотации обязательно.
              </span>
            </p>
            <br />
            <p>
              <b>Жанр: </b>
              <span>
                Любовное фэнтези + попаданчество. Допускается наличие третьего дополнительного жанра
                (например, детектив, боевое фэнтези и т.д). Любовная линия и классический счастливый конец обязательны.
                Из аннотации должно быть четко ясно, что ваша книга о попаданке, которая волею случая оказывается в
                магическом мире, о ее обустройстве в новом мире и
                о встрече с мужчиной, который окажется ее второй половинкой.
              </span>
            </p>
            <p>
              <b>Объем: </b>
              <span>
                от 360&nbsp;000 до 600 000 с пробелами, для завершенного произведения.
                Минимальный объем текста для подачи заявки — 100&nbsp;000 знаков для романа,
                имеющего статус&nbsp; «в процессе».
              </span>
            </p>
            <p>
              <b>Форма произведения: </b>
              <span>роман.</span>
            </p>
            <p>
              <b>Возрастной ценз:</b>
              <span> 16+ (никакого многомужества!)</span>
            </p>
            <p>
              <b>Статус произведения на момент подачи заявки:</b>
              <span>
                {' '}
                «полностью» или «в процессе»,
                с условием, что произведение будет выложено полностью до 15.08.2023г.
                (до 00:00 16.08.2023 по МСК. Все кто не
                успеет завершить свою работу до этого времени, будут сняты с конкурса).
              </span>
            </p>
            <p>
              <b>В конкурсных работах не должно быть:</b>
              {' '}
              <span>
                романов, продолжающих цикл; фанфиков по другим произведениям;
                текстов, содержащих огромное количество орфографических ошибок;
                произведений, содержание которых противоречит законодательству РФ;
                романов с рейтингом 18+
              </span>
            </p>
            <br />
            <p>
              <span>Заявка отправляется на почту </span>
              <a href="mailto:ads@bookriver.ru"><span>ads@bookriver.ru</span></a>
            </p>
            <p>
              <b>Тема письма:</b>
              <span> Герцог, ректор, два дракона</span>
            </p>
            <p>
              <span>К заявке необходимо приложить синопсис (краткое описание сюжета, персонажей) в формате </span>
              <b>.doc или .docx </b>
              <span>
                Объем синопсиса до 10&nbsp;000 знаков с пробелами. Один автор
                может предложить только одну книгу! Соавторские работы закрепляются
                сразу за двумя авторами.
              </span>
            </p>
            <p>
              <span>
                Название документа с синопсисом указывайте в формате «Автор —
                Название романа — синопсис». Шапка синопсиса должна содержать:
              </span>
            </p>
            <p><span>1. Имя/псевдоним автора</span></p>
            <p><span>2. Название произведения</span></p>
            <p><span>3. Ссылку на произведение на Bookriver.</span></p>
            <p><h3>Заявки без синопсиса будут отклоняться без рассмотрения!</h3></p>

            <p>
              <h3>
                О том, что такое синопсис, вы можете прочитать тут
                {' '}
                <PostLink slugPost="sinopsis--shpargalka-dlya-avtora-3394">
                  <a>
                    (ссылка на блог)
                  </a>
                </PostLink>
              </h3>
            </p>
          </>
        ),
      }}
    />
  );
};
